<!-- eslint-disable -->
<template>
    <div class="main-wrapper">
        <div class="page-wrapper full-page">
            <div class="page-content d-flex align-items-center justify-content-center">
                <div class="row w-100 mx-0 auth-page">
                    <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center">
                        <h4 class="mb-2"> Bienvenu {{ StateUser?.firstName }} {{ StateUser?.lastName }}</h4>
                        <p>Pour commencer, veuillez ajouter un restaurant </p>
                        <a href="/creation-restaurant" class="nav-link mt-3">
                            <span class="link-title">Ajouter un Restaurant</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- eslint-disable -->
<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
    computed: {
        ...mapState({ LibSite: "LibSite" }),
        ...mapGetters({ isRole: "isRole", isAuthenticated: "isAuthenticated", BaseUrl: "StateBase", currentSite: "currentSite", StateUser: "StateUser" }),
    },
    mounted() {
    }
}

</script>